import { MainLoader, ResourceLoader, startManualAddressEntryByName, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Form, FormPageTitle, redirectTo } from 'omni-package-react-core';
import { useDispatch } from 'react-redux';
import { PersonalInformation } from '../../../interfaces/PersonalInformation';
import { PersonalInformationDto } from '../../../interfaces/dtos/PersonalInformationDto';
import getApiRoot from '../../../utils/getApiRoot';
import AboutYouSection from './AboutYouSection';
import EditMailSection from './EditMailSection';
import CorrespondenceSection from './CorrespondenceSection';
import EditPhoneSection from './EditPhoneSection';
import EditAddressSection from './EditAddressSection';
import transformFormRequest from './transformFormRequest';
import transformFormResponse from './transformFormResponse';
import { PersonalInfosChangeDataDto } from '../../../interfaces/dtos/PersonalInfosChangeDataDto';
import Constants from '../../../Constants';
import { PersonalInfosChangeData } from '../../../interfaces/PersonalInfosChangeData';
import { PersonalInfoResourceInfo } from '../../../components/PersonalInformationResource/PersonalInformationResource';

export interface PersonalInformationsFormProps { }

const PersonalInformationsForm: FC<PersonalInformationsFormProps> = () => {
  const { t } = useTranslation('PersonalInformationsFormPage');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const personalInfo: PersonalInformation = useScopedSelector(PersonalInfoResourceInfo.dataDst);

  const fields: Record<string, string> = {
    phoneNumberHome: 'phones.home',
    phoneNumberWork: 'phones.work',
    phoneNumberWorkExtension: 'phones.workExtension',
    phoneNumberCell: 'phones.cell',
    phoneNumberFax: 'phones.fax',
    emailHome: 'emails.home',
    emailWork: 'emails.work',
    civicNumber: 'newAddress|buildingNumber',
    street: 'newAddress|street',
    city: 'newAddress|city',
    province: 'newAddress|province',
    country: 'newAddress|countryIso2',
    postalCode: 'newAddress|postalCode',
    appartementOrSuite: 'newAddress|subBuilding',
    externalPlace: 'newAddress|place',
    deliveryMethod: 'newAddress|deliveryType',
    postOfficeBox: 'newAddress|poBoxNumber',
    ruralRoute: 'newAddress|ruralRoute',
    appartementOrSuiteType: 'newAddress|subBuildingType',
  };

  let responseData: PersonalInfosChangeData = null;
  return (
    <>
      <FormPageTitle>{t('title')}</FormPageTitle>
      <ResourceLoader
        inlineErrorMessage={false}
        buttonAlign="left"
        resourceSrc={PersonalInfoResourceInfo.name}
        CustomLoader={MainLoader}
      >
        <Form<PersonalInformation, PersonalInformationDto>
          name="personalInformationsForm"
          url={`${getApiRoot()}/personal-information`}
          createMethod="PUT"
          valuesSrc="info"
          initialValues={personalInfo}
          transformResponse={({ data }: { data: PersonalInfosChangeDataDto }) => {
            responseData = transformFormResponse(data);
            return personalInfo;
          }}
          transformRequest={(values: PersonalInformation) => transformFormRequest(values)}
          controlErrorMapping={fields}
          onSuccess={() => {
            redirectTo(Constants.PersonalInformationsConfirmationPagePath, navigate, { data: responseData });
          }}
          onFailure={() => {
            dispatch(startManualAddressEntryByName('newAddress'));
          }}
        >
          <AboutYouSection personalInfo={personalInfo} />
          <EditMailSection />
          <EditPhoneSection />
          <EditAddressSection personalInfo={personalInfo} />
          <CorrespondenceSection />
        </Form>
      </ResourceLoader>
    </>
  );
};

export default (PersonalInformationsForm);
